import { forwardRef } from "react";

import dynamic from "next/dynamic";

import { DrawerProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
const DynamicDashboardDrawer = dynamic(() => import("./DashboardDrawerSsr").then((mod) => mod.DashboardDrawerSsr), {
  ssr: false,
});

// Wrap dynamic component with forwardRef and pass ref as forwardedRef prop
// This is necessary because next/dynamic doesn't properly forward refs
export const DashboardDrawer = forwardRef<HTMLDivElement, DrawerProps>((props, ref) => (
  <DynamicDashboardDrawer {...props} forwardedRef={ref} />
));

DashboardDrawer.displayName = "DashboardDrawer";
